import { useState } from 'react';
import IconComponent from './icons';
import { rectifyUndefinedState } from '../utils/helpers';
import NavigationPanel from './Header/NavigationPanel';
import styles from './nav-button.module.scss'
import ScrollLock from "../utils/scroll-lock"

const NavButton = (props) => {

  const {title} = props;
  let {menuactive, classes, icon, href, target} = props;
  menuactive = rectifyUndefinedState(menuactive);
  icon = rectifyUndefinedState(icon);
  href = rectifyUndefinedState(href);
  target = rectifyUndefinedState(target);
  classes = (classes!=='undefined') ? classes : '';

  const [showNav, toggleNav]= useState(false);

  const toggleNavVisibility = (title)=> {
    const childElements = Array.from(document.querySelectorAll('[id^="nav-child"]'));
    childElements.forEach((element)=>{
      if(element.classList.contains('block'))element.classList.remove('block');
      if(!element.classList.contains('hidden'))element.classList.add('hidden');
    });
    if(showNav) {
      ScrollLock.enable()
    } else {
      ScrollLock.disable()
    }
    toggleNav(!showNav);
  }

  const getNavItemText = (active, icon, title, href,target) => {
    if(icon){
      return (
      <span className={active?'nav-border-active':''} onTouchStart={()=>toggleNavVisibility(title)}>
        <span className="text-sm 2xl:text-base">{title}</span>
        <span>
          <IconComponent icon={icon} className='inline ml-2 mt-1' width='24' height='16'/>
        </span>
      </span>);
    }
    return (<a href={href} target={target}><span className={active?'nav-border-active':''}>{title}</span></a>)
  }

  const overViewData= {title:'Overview', overviewTitle:title, href,target};

    return (
        <span className={`${classes} ${styles.header} group cursor-pointer lg:text-sm`}>
          {getNavItemText(menuactive, icon, title,href,target)}
          {icon ? 
          <div id={`nav-child-${title}`} className={`${showNav?'block':'hidden'} absolute top-[70px] left-0 group-hover:block z-50 overflow-y-auto bg-white shadow w-full max-h-[90vh]`}>
            <NavigationPanel navigation={props.data['em-nav-item']} overViewData={overViewData} ctaAction={props.ctaaction}/>
          </div> : 
          null}
        </span>
        )
}

export default NavButton;